const BUCKET_NAME = 'alerts.status';

export default class ThingStatusController {
    /** @ngInject */
    constructor(NotificationsService, EventEmitter) {
        this.NotificationsService = NotificationsService;
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        if (!this.thingStatus) {
            this.thingStatus = [];
        }

        this.notifications = this.NotificationsService.getAllNotifications();
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    onChange() {
        if (this.thingStatus.length) {
            this.fillBucket();

            this.pushUpdate(
                this.eventEmitter(
                    {
                        value: this.thingStatus
                    }
                )
            );
        } else {
            this.clearBucket();
        }
    }

    exists(notification) {
        return this.thingStatus.indexOf(notification.value) > -1;
    }

    toggle(notification) {
        const index = this.thingStatus.indexOf(notification.value);

        if (index > -1) {
            this.thingStatus.splice(index, 1);
        } else {
            this.thingStatus.push(notification.value);
        }

        this.onChange();
    }

    fillBucket() {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingStatus
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        // this.thingStatus = [];

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-status/thing-status.controller.js